import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';

import { CrudComponent } from '@admin/components/crud/crud.component';
import { CrudHeaderComponent } from '@admin/components/crud-header/crud-header.component';
import { Ranking } from '@admin/models/Ranking.model';
import { SearchBarComponent } from '@admin/components/search-bar/search-bar.component';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { ElementModel } from '@shared/models/Element.model';
import { Pagination } from '@shared/models/Pagination.model';

@Component({
  selector: 'app-ranking',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatPaginatorModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    AlertComponent,
    CrudHeaderComponent,
    SearchBarComponent,
  ],
  // templateUrl: './ranking.component.html',
  templateUrl: '../../components/crud/crud.component.html',
  styleUrl: './ranking.component.scss',
})
export class RankingComponent extends CrudComponent {
  override data: Pagination<Ranking> = new Pagination(Ranking);
  override filters: ElementModel[] = [
    { label: 'Activo', value: '1' },
    { label: 'Inactivo', value: '0' },
  ];

  override handleLoadResponse(responses: any[]): void {
    if (responses[0].data) this.data.setData(responses[0].data);

    this.pagination.set(this.data.rows.length > 0);
    this.stopLoading();
  }
}
